/** @jsx jsx */
import { jsx } from '@emotion/react';
import PropTypes from 'prop-types';

import Flex from '../../../../../researcher/blocks/flex/flex';
import {
  PAGES__SHAPE_ARRAY,
  SURVEY_CLIENT__SHAPE_ITEM,
} from '../../../../../researcher/redux/constants';

import { bar, bullets, bullet, overlay, progressWrap, progressBG } from './nav--small.style';

import { getIcon } from '../nav--large/nav.item';

const SmallNav = ({ currentPageIndex, pages, progress, toggleProgress, surveyClient }) => (
  <div>
    <div // eslint-disable-line
      css={progressWrap}
      onClick={toggleProgress}
    >
      <div css={progressBG}>
        <div css={bar} style={{ width: `${progress}%` }} />
      </div>
    </div>
    {surveyClient.showProgress && (
      <Flex alignItems="center" css={overlay} element="nav" flexDirection="column">
        <div css={bullets}>
          {pages.map(({ id }, key) => (
            <div
              key={id}
              css={bullet({
                past: key < currentPageIndex,
                current: key === currentPageIndex,
                next: key > currentPageIndex,
              })}
            >
              {getIcon(id, key + 1)}
            </div>
          ))}
        </div>
      </Flex>
    )}
  </div>
);

SmallNav.propTypes = {
  currentPageIndex: PropTypes.number.isRequired,
  pages: PAGES__SHAPE_ARRAY.isRequired,
  progress: PropTypes.number.isRequired,
  toggleProgress: PropTypes.func.isRequired,
  surveyClient: SURVEY_CLIENT__SHAPE_ITEM.isRequired,
};

export default SmallNav;
